import { useEffect } from 'react';

import { useThrottledCallback } from 'use-debounce';

import { getPing } from '@api/queries';

const activityEvents = [
  'mousedown', // mouse click
  'keydown', // keyboard press
  'scroll', // page scroll
  'wheel', // mouse wheel scroll
  'focus', // window/tab focus
  'video-still-playing'
];

export const useActivityPing = () => {
  const { callback } = useThrottledCallback(() => getPing(), 60_000, { leading: true, trailing: false });

  useEffect(() => {
    const handleActivity = () => {
      callback();
    };

    // Attach event listeners for activity events
    activityEvents.forEach((event) => {
      window.addEventListener(event, handleActivity, { passive: true });
    });

    // Cleanup function to remove event listeners
    return () => {
      activityEvents.forEach((event) => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, [callback]);
};
